import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Insights from './pages/Insights';
import InsightArticle from './pages/InsightArticle';
import About from './pages/About';
import Contact from './pages/Contact';
import LogoPreview from './pages/LogoPreview';
import { Toaster } from './components/ui/toaster';

function ScrollTop() {
  const { pathname, hash } = window.location;
  React.useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App bg-white text-[#0F2A44]">
      <BrowserRouter>
        <ScrollTop />
        <Navbar />
        <main className="pt-[88px]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:id" element={<InsightArticle />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/logos" element={<LogoPreview />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
